export enum AvailableSearchParams {
  THEME = 'theme',
  APP = 'app',
  FLOW = 'flow'
}

export const getSearchParam = (key: AvailableSearchParams, defaultValue?: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(key) ?? defaultValue;
};
